import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleUp, faCircleDown } from '@fortawesome/free-regular-svg-icons'
import { faXmark, faCircleNotch, faRotate } from '@fortawesome/free-solid-svg-icons'
import { useState, useRef, useEffect } from "react";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import { formatCurrency} from '../utils/currencyUtils';
import Select from "react-select";

function RowList3({data}) {  
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalIsOpen1, setIsOpen1] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [amount, setAmount] = useState(0);
    const [type, setType] = useState("profit");
    const [status, setStatus] = useState(data.status);
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    const menuRef = useRef();
    useEffect(() => {
        function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setShowMenu(false);
        }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const AddProfit = () => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ setProfit1: true, id: data.id, type:type, amount:amount })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
                window.location.reload();
            }else{
              toast.error(data.message);
            }
            setLoading(false);
          })
          .catch(err => {
            console.error(err);
            setLoading(false);
        })
    }
    const UpdateTrade = () => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ updateTrade: true, id: data.id, status:status })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
                window.location.reload();
            }else{
              toast.error(data.message);
            }
            setLoading(false);
          })
          .catch(err => {
            console.error(err);
            setLoading(false);
        })
    }
    const Delete = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ deleteTrade1: true, id: id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const typeoptions = [
        { value: "profit", label: "Add profits" },
        { value: "loss", label: "Add loss" }
    ];
    const statusoptions = [
        { value: "position", label: "Position" },
        { value: "closed", label: "Closed" },
        { value: "open", label: "Open" }
    ];

    useEffect(() => {
        if(type && amount){
            setDisable(false);
        }else{
            setDisable(true);
        }
    }, [type, amount]);
    const darkThemeStyles = {
        control: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
          border: "none",
          color: "#fff",
          minWidth: "135px"
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
          color: "#fff",
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#fff",
        }),
    };
    return (
        <>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Add profits</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <p className="mb-3 text-light fw-semibold" style={{fontSize: '15px'}}>Add profits or loss to this trade. The profits (or loss) will be added to user's USD account once the trade is closed</p>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Type:</label>
            <Select 
                options={typeoptions} 
                value={typeoptions.find((opt) => opt.value === type)}
                onChange={(e) => setType(e.value)}
                styles={darkThemeStyles}
                className="w-full"
            />
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="1000" 
                    className="inputNone"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                USDT
                </div>
            </div>
            <div className='d-flex align-items-center mt-3 justify-content-between'>
                <p className='mb-0'>Entry price</p>
                <p className='mb-0 fw-bold'>${formatCurrency(data.price)}</p>
            </div>
            <div className='d-flex align-items-center justify-content-between'>
                <p className='mb-0'>Direction</p>
                <p className='mb-0 fw-bold'>{data.side.charAt(0).toUpperCase() + data.side.slice(1)}</p>
            </div>
            <div className='d-flex align-items-center justify-content-between'>
                <p className='mb-0'>Current pnl:</p>
                <p className='mb-0 fw-bold'>${formatCurrency(data.pl_roi)}</p>
            </div>
            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => {if (!disable) {AddProfit();}
            }}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:`Add ${formatCurrency(amount)} ${type}`}</div>
        </Modal>
        <Modal
          isOpen={modalIsOpen1}
          onRequestClose={() => setIsOpen1(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Update Trade Status</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen1(false)} />
            </div>
            <p className="mb-3 text-light fw-semibold" style={{fontSize: '15px'}}> Update the trade status and specify the profit or loss. When the trade is closed, the final profit or loss will be credited to or deducted from the user's USD account.</p>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Select Status:</label>
            <Select 
                options={statusoptions} 
                value={statusoptions.find((opt) => opt.value === status)}
                onChange={(e) => setStatus(e.value)}
                styles={darkThemeStyles}
                className="w-full"
            />
            <div className='d-flex align-items-center mt-3 justify-content-between'>
                <p className='mb-0'>Entry price</p>
                <p className='mb-0 fw-bold'>${formatCurrency(data.price)}</p>
            </div>
            <div className='d-flex align-items-center justify-content-between'>
                <p className='mb-0'>Direction</p>
                <p className='mb-0 fw-bold'>{data.side.charAt(0).toUpperCase() + data.side.slice(1)}</p>
            </div>
            <div className='d-flex align-items-center justify-content-between'>
                <p className='mb-0'>Current pnl:</p>
                <p className='mb-0 fw-bold'>${formatCurrency(data.pl_roi)}</p>
            </div>
            <p className='mt-2 mb-0' style={{fontSize:'12px'}}>Note:</p>
            <div className={`myBtn w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => {UpdateTrade()}
            }>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:`Update`}</div>
        </Modal>
        <tr className="fw-semibold">
            <td>#{data.order_id}</td>
            <td>
                <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center justify-content-center rounded-2 text-prime fw-semibold' style={{backgroundColor:'#ffffff0d', width: '32px', height: '32px'}}>
                        <span>{data?.user?.fullname.charAt(0)}</span>
                    </div>
                    <span className='ms-2 text-nowrap'>{data?.user?.fullname}</span>
                </div>
            </td>
            <td className='text-nowrap'>{data.order_time}</td>
            <td className='text-nowrap'><img src={data.logo} alt="Method" style={{width: '20px'}} /> <span className='ms-2 fw-bold text-nowrap'>{data.pair}</span></td>
            <td className='text-nowrap'>{data.type}</td>
            <td className='text-nowrap'>{data.leverage}x</td>
            <td className='text-nowrap'>{data.side}</td>
            <td className='text-nowrap'>{data.future_type}</td>
            <td className="text-nowrap fw-bold">
              {formatCurrency(data.amount)} USDT{" "}
              <FontAwesomeIcon
                className={`ms-1 ${
                  data.side === "Long"
                    ? "text-success"
                    : data.side === "Short"
                    ? "text-danger"
                    : "text-prime"
                }`}
                icon={
                  data.side === "Long"
                    ? faCircleUp
                    : data.side === "Short"
                    ? faCircleDown
                    : faRotate
                }
                style={{ fontSize: "15px" }}
              />
            </td>
            <td
              className={`text-nowrap fw-bold 
                ${data.pl_roi >= 0 
                  ? "text-success" 
                  : data.pl_roi < 0 
                  ? "text-danger" 
                  : "text-prime"}`}
            >
              ${formatCurrency(data.pl_roi)}
            </td>
            <td className={`${data.status === 'position' ? 'text-success' : data.status === 'closed' ? 'text-danger' : 'text-warning'}`}>{data.status === 'position' ? 'Position' : data.status === 'closed' ? 'Closed' : 'Open'}</td>
            <td style={{ position: "relative" }}>
                <div
                className="myBtn d-inline-block px-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowMenu((prev) => !prev)}
                >
                Edit
                </div>
                {showMenu && (
                <div
                    ref={menuRef}
                    className="dropdown-menu-custom"
                    style={{
                    position: "absolute",
                    top: "35px",
                    right: 0,
                    background: "#232528",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    zIndex: 10,
                    minWidth: "120px",
                    padding: "5px",
                    }}
                > 
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => setIsOpen(true)}>
                    Add Profits
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => setIsOpen1(true)}>
                    Update Status
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Delete(data.id)}>
                    Delete
                    </div>
                </div>
                )}
            </td>
        </tr>
        </>
    )
  }
  
  export default RowList3